import React, { useEffect, useState } from "react";
import ChatUIComponent from "../CommonChatComponent";
import PageTitleSection from "components/common/PageTitleSection";
import BreadCrumb from "components/common/BreadCrumb";
import { flowActions } from "redux/Ldb/actions";
import { useAppDispatch } from "hooks/storeHooks";
import useGetUserFlowMode from "hooks/Flow/useGetUserFlowMode";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";

const FlowChat = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { mode: flowMode } = useGetUserFlowMode();

    const [mode, setMode] = useState<string>("");
    const handleModeChange = (mode: string) => {
        dispatch(flowActions.setFlowMode(mode));
    };

    useEffect(() => {
        setMode(flowMode ?? "operator");
    }, [flowMode]);

    return (
        <div>
            <div className="mb-3 ">
                <PageTitleSection
                    className="!py-[10px]"
                    leftComp={
                        <BreadCrumb
                            parentClassName="!text-slate-900"
                            parentCrumb={""}
                            size="large"
                            parentIcon={
                                <i
                                    className={`-mt-0.5 text-slate-500 text-base cursor-pointer transition-all duration-300
                                        ri-home-5-line`}
                                    onClick={() => {
                                        navigate("/dashboard/home");
                                    }}
                                ></i>
                            }
                        />
                    }
                    rightComp={
                        <div className="flex bg-[#F8FAFC] rounded-lg p-1">
                            {[
                                {
                                    title: "Operator mode",
                                    mode: "operator",
                                    icon: "ri-tools-fill",
                                },
                                {
                                    title: "Flow mode",
                                    mode: "flow",
                                    img: "https://storage.googleapis.com/heysynth_files/synth_web/wave-line.svg",
                                },
                            ].map((item) => (
                                <div className="">
                                    <a id={`${item.mode}`}>
                                        <div
                                            className={`flex items-center gap-1.5  py-0.5 px-3 font-rocGroteskMedium ${
                                                mode === item.mode && mode === "flow"
                                                    ? "bg-white border border-[#00C6FA] rounded-md"
                                                    : mode === item.mode && mode === "operator"
                                                    ? "bg-white border border-[#FD700B] rounded-md"
                                                    : "bg-[#F8FAFC]"
                                            } cursor-pointer`}
                                            onClick={() => {
                                                setMode(item.mode);
                                                handleModeChange(item.mode);
                                            }}
                                        >
                                            {item?.icon ? (
                                                <i className={`${item.icon} text-[#FD700B]`}></i>
                                            ) : (
                                                <img
                                                    src={item?.img}
                                                    alt="flow"
                                                    className="w-4 h-4"
                                                />
                                            )}
                                            <p className={` text-g-75 text-[13px]`}>{item.title}</p>
                                        </div>
                                    </a>

                                    <Tooltip
                                        anchorSelect={`#${item.mode}`}
                                        place="top"
                                        content={
                                            item?.mode === "flow"
                                                ? "Simplified, focused workspace to collaborate, track, and decide together."
                                                : "Detailed ops view for advanced controls."
                                        }
                                        style={{
                                            width: "290px",
                                            zIndex: 9999,
                                            backgroundColor: "#142837",
                                            color: "#fff",
                                            fontSize: "13px",
                                            fontWeight: "400 !important",
                                            borderRadius: "8px",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    }
                />
            </div>
            <ChatUIComponent pageType="flow" mode={flowMode} />
        </div>
    );
};

export default FlowChat;
